module.exports = __webpack_public_path__ + "static/wlbg02-4a4dc50867d0b8b20fc67575b8d8c1c8.jpg";